import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  FeatureStatusState,
  UpdateFeatureStatusPayload,
} from "./featureStatus.types";

const initialState: FeatureStatusState = {
  visibility: {
    bysegment: false,
    bybrand: false,
    bymarket: false,
  },
  equity: {
    bysegment: false,
    bybrand: false,
    bymarket: false,
  },
  conversion: {
    bysegment: false,
    bybrand: false,
    bymarket: false,
  },
  emotional: {
    bysegment: false,
    bybrand: false,
    bymarket: false,
  },
  advertising: {
    bysegment: false,
    bybrand: false,
    bymarket: false,
  },
  reputation: {
    bysegment: false,
    bybrand: false,
    bymarket: false,
  },
  reports: {
    enabled: false,
  },
  aiAssistant: {
    enabled: false,
  },
  exclusivequestions: {
    bybrand: false,
    bysegment: false,
  },
  legacyScore: {
    enabled: false,
  },
  meanScore: {
    enabled: false,
  },
  brandSet: {
    enabled: false,
  },
  aivisibility: {
    bybrand: false,
    bymodel: false,
  },
};

const featureStatusSlice = createSlice({
  name: "featureStatus",
  initialState,
  reducers: {
    updateFeatureStatus(
      state,
      action: PayloadAction<UpdateFeatureStatusPayload>,
    ) {
      const { feature, property, value } = action.payload;
      if (state[feature]) {
        state[feature][property] = value;
      }
    },
    setFeatureStatusInitially(state, action: PayloadAction<any>) {
      state = {
        ...state,
        ...action?.payload,
      };
      return state;
    },
  },
});

export const { updateFeatureStatus, setFeatureStatusInitially } =
  featureStatusSlice.actions;
export default featureStatusSlice.reducer;
